export default __webpack_public_path__ + "static/media/bg_features.935158e7.jpg";